"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrencySymbol = exports.getCurrencyFormat = void 0;

var _locale = require("./locale");

var _Logger = _interopRequireDefault(require("./Logger"));

var getCurrencySymbol = function getCurrencySymbol(currency) {
  switch (currency) {
    case 'SEK':
      return 'kr';

    case 'NOK':
      return 'kr';

    case 'EUR':
      return '€';

    default:
      {
        _Logger["default"].warn("Currency symbol for '".concat(currency, "' not configured, fallback to ").concat(currency));

        return currency;
      }
  }
};

exports.getCurrencySymbol = getCurrencySymbol;

var getCurrencyFormat = function getCurrencyFormat(amount, currency, locale) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    decimals: 2
  };

  if (locale) {
    return new Intl.NumberFormat((0, _locale.getLocaleFromLanguageCode)(locale), {
      style: 'currency',
      currency: currency
    }).format(amount);
  } else {
    _Logger["default"].warn('Locale not sent to getCurrencyFormat, formatting it manually.');

    var symbol = getCurrencySymbol(currency);
    var number = Number(amount).toFixed(options.decimals);
    var symbolFirst = "".concat(symbol).concat(number);
    var amountFirst = "".concat(number, " ").concat(symbol);

    switch (currency) {
      case 'NOK':
      case 'SEK':
        return amountFirst;

      case 'EUR':
        return symbolFirst;

      default:
        {
          _Logger["default"].warn("Currency '".concat(currency, "' not configured, fallback to ").concat(amountFirst));

          return amountFirst;
        }
    }
  }
};

exports.getCurrencyFormat = getCurrencyFormat;